const AttendanceType = {
  attendance1: "Students",
  attendance2: "Teachers",
};

export default AttendanceType;
